"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingComponent = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2021 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var baseAnimationDuration = 1.4;
/**
 * {@link http://sdk.gooddata.com/gooddata-ui/docs/loading_component.html | LoadingComponent }
 * is a component that renders a default loading indicator.
 *
 * @public
 */
var LoadingComponent = /** @class */ (function (_super) {
    tslib_1.__extends(LoadingComponent, _super);
    function LoadingComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LoadingComponent.prototype.render = function () {
        var _a = this.props, inline = _a.inline, width = _a.width, height = _a.height, imageWidth = _a.imageWidth, imageHeight = _a.imageHeight, color = _a.color, _b = _a.speed, speed = _b === void 0 ? 1 : _b, className = _a.className;
        var duration = baseAnimationDuration / speed;
        var delay = duration / -5;
        var dotStyles = {
            transformOrigin: "4px 4px",
            animation: "GDC-pop " + duration + "s infinite",
            animationDelay: delay * 2 + "s",
            fill: color,
        };
        var wrapperStyles = {
            textAlign: "center",
            display: inline ? "inline-flex" : "flex",
            verticalAlign: "middle",
            flexDirection: "column",
            alignContent: "center",
            justifyContent: "center",
            flex: "1 0 auto",
            height: height,
            width: width,
        };
        var svgStyles = {
            maxHeight: "100%",
            maxWidth: "100%",
            flex: "0 1 auto",
            width: imageWidth,
            height: imageHeight,
        };
        var dot1Styles = dotStyles;
        var dot2Styles = tslib_1.__assign(tslib_1.__assign({}, dotStyles), { transformOrigin: "18px 4px", animationDelay: delay + "s" });
        var dot3Styles = tslib_1.__assign(tslib_1.__assign({}, dotStyles), { transformOrigin: "32px 4px", animationDelay: "0" });
        return (react_1.default.createElement("div", { className: className, style: wrapperStyles },
            react_1.default.createElement("svg", { style: svgStyles, version: "1.1", x: "0px", y: "0px", viewBox: "0 0 36 8" },
                react_1.default.createElement("style", { scoped: true }, "\n                        @keyframes GDC-pop {\n                            0%,\n                            80%,\n                            100% {\n                                transform: scale(0);\n                            }\n                            40% {\n                                transform: scale(1);\n                            }\n                        }\n                    "),
                react_1.default.createElement("g", { style: dot1Styles },
                    react_1.default.createElement("circle", { cx: "4", cy: "4", r: "4" })),
                react_1.default.createElement("g", { style: dot2Styles },
                    react_1.default.createElement("circle", { cx: "18", cy: "4", r: "4" })),
                react_1.default.createElement("g", { style: dot3Styles },
                    react_1.default.createElement("circle", { cx: "32", cy: "4", r: "4" })))));
    };
    LoadingComponent.defaultProps = {
        className: "s-loading",
        color: "var(--gd-palette-complementary-6, #94a1ad)",
        speed: 1,
        inline: false,
        height: "100%",
        width: undefined,
        imageHeight: 8,
        imageWidth: undefined,
    };
    return LoadingComponent;
}(react_1.default.Component));
exports.LoadingComponent = LoadingComponent;
//# sourceMappingURL=LoadingComponent.js.map